<template>
    <div :class="classes">

        <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
            :class="iconClasses || 'w-5 h-5'">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <path fill="currentColor"
                        d="M14.994 10c.03 0 .06.005.108.01.504.05.898.485.898.99v6c0 .505-.394.94-.92.992L15 18H8.255l-.563.487L5 20.814V18H3c-.542 0-1-.458-1-1v-6c0-.542.458-1 1-1h11.994M15 8H3c-1.65 0-3 1.35-3 3v6c0 1.65 1.35 3 3 3v3c0 .39.23.75.58.91.14.06.28.09.42.09.24 0 .47-.08.65-.24L9 20h6c.1 0 .21-.01.3-.02 1.51-.15 2.7-1.43 2.7-2.98v-6c0-1.55-1.19-2.83-2.7-2.98-.09-.01-.2-.02-.3-.02z">
                    </path>
                    <path fill="currentColor"
                        d="M24 3v6c0 1.65-1.35 3-3 3-.55 0-1-.45-1-1s.45-1 1-1c.54 0 1-.46 1-1V3c0-.54-.46-1-1-1H9c-.54 0-1 .46-1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V3c0-1.65 1.35-3 3-3h12c1.65 0 3 1.35 3 3z">
                    </path>
                </g>
            </svg>

    </div>
</template>

<script>
export default {
    name: "AudioIcon",
    props: {
        fill: {
            type: String,
            default: "currentColor",
        },
        classes: {
            type: String,
            default: "",
        },
        iconClasses: {
            type: String,
            default: "",
        },
    },
}

</script>